/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './job-insurance-rest.service';
export * from './job-insurance.dto';
